(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vva-package-popup"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vv-package-popup')){
 customElements.define('vv-package-popup',class extends HTMLElement{
  connectedCallback(){
   this.dialog=this.querySelector('dialog');
   this.key='vv-package-promo-sep-2026';
   this.closeButtons=this.querySelectorAll('.vva-package-popup-close,.vva-package-popup-dismiss');
   this.close=()=>{this.dialog.close();try{sessionStorage.setItem(this.key,'dismissed')}catch(e){}};
   this.closeButtons.forEach(button=>button.addEventListener('click',this.close));
   this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.close()});
   let dismissed=false;
   try{dismissed=sessionStorage.getItem(this.key)==='dismissed'}catch(e){}
   if(!dismissed)setTimeout(()=>{if(!this.dialog.open)this.dialog.showModal()},1400);
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
